import { SpotterTelemetryCapabilities } from '@/api/subscriptionTags/types';

export const telemetryTypeToLabelMap: Record<SpotterTelemetryCapabilities, string> = {
    iridium: 'satellite',
    cellular: 'cellular',
} as const;
